import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxGridService } from './../../checkbox-grid.service';

@Component({
  selector: 'checkbox-grid-header-cell',
  templateUrl: './checkbox-grid-header-cell.component.html',
  styleUrls: ['./checkbox-grid-header-cell.component.scss'],
})
export class CheckboxGridHeaderCellComponent {
  @Input() isBulkSupported;
  @Input() column;
  @Input() isReadOnly: boolean;
  checked: boolean;
  @Output() columnUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private checkboxGridService: CheckboxGridService) {}

  handleBulkClicked(prop) {
    this.checked = !this.checked;
    prop.bulkChecked = this.checked;
    this.columnUpdated.emit(prop);
  }
}
